export const languageMapping: Record<string, string> = {
    cs: 'cs_CZ',
    de: 'de_DE',
    'de-CH': 'de_DE',
    en: 'en_US',
    'es-ES': 'en_US', // No Spanish in target list, fallback to English
    fr: 'fr_FR',
    'fr-CH': 'fr_FR',
    hu: 'en_US', // No Hungarian in target list, fallback to English
    'it-CH': 'it_IT',
    'it-IT': 'it_IT',
    ja: 'ja_JP',
    nl: 'en_US', // No Dutch in target list, fallback to English
    ro: 'en_US', // No Romanian in target list, fallback to English
};
